import React from 'react';
import { Box } from '@mui/material';
import TileShell from '../../../components/tiles/TileShell';
import InterviewsBadge from '../../../components/tiles/InterviewsBadge';
import ScoreBadge from '../../../components/tiles/ScoreBadge';

export default function ProductBadgeTile({ title, count, pct, avgSatisfaction, href }) {
  const metricsRow = (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      <InterviewsBadge percent={pct} count={count} />
      {Number.isFinite(avgSatisfaction) && (
        <ScoreBadge label="Satisfaction" value={avgSatisfaction} metricKey="satisfaction" />
      )}
    </Box>
  );

  return (
    <TileShell
      typePill="product"
      title={title}
      metricsRow={metricsRow}
      linkTo={href}
      href={href}
    />
  );
}
